import { MouseEvent, useState } from 'react';
import { toast } from '#/components/UnifiedRfqs/toast';
import { useGrfqService } from '@paradigm/features/src/unified-rfqs/contexts/grfqs';
import { razzmatazz } from '@paradigm/design-system/src/colors';
import BoldCross from '@paradigm/design-system/src/assets/BoldCross';
import { useOBV1APIFeatureFlag } from '@paradigm/features/src/feature-flags/context';
import { GrfqQuote } from '@paradigm/features/src/unified-rfqs/entities/grfq/domain';
import PillButton from '../components/PillButton';

interface Props {
  readonly quoteId: GrfqQuote['id'];
}

export default function KillQuoteButton({ quoteId }: Props) {
  const grfqService = useGrfqService();
  const isGrfqV2API = useOBV1APIFeatureFlag();
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setIsLoading(true);
    event.stopPropagation();
    grfqService
      .killQuote({ quoteId })
      .then((resp) => {
        // GRFQ V2 API does not contain messages when unsuccessful
        if (!resp.ok && !isGrfqV2API) {
          toast(resp.message);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <PillButton
      ariaLabel="Kill quote"
      onClick={handleClick}
      icon={<BoldCross width={9} color={razzmatazz} />}
      iconPlacement="left"
      disabled={isLoading}
    >
      Kill
    </PillButton>
  );
}
